import {URL_API_USER_DATA_AUDITOR_LIST, URL_API_USER_DATA_SUPERVISOR_SEARCH, URL_API_USER_DATA_AGENT_SEARCH, URL_API_USER_DATA_AGENT_MAP, URL_API_REASSIGN_AGENTS, URL_API_MAPPED_AGENTS_LIST_VIEW} from '../apiHitFile';
import  _ from  'lodash';
import {showModalLogin} from '../Dashboard/UserActions';
export function AuditorListAction(data) {  
  return (dispatch, getState) => { 
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization", currentToken);
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    let obj = {userId: getState().LoginReducer.loginAction.userName,searchQa:data.enteredVal}
    dispatch(isPending())
    fetch(URL_API_USER_DATA_AUDITOR_LIST, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then(res=>res.json())
     .then(json => {
       if(json.status === 403){
        dispatch(showModalLogin(json))
       } else {
        console.log(json,"retrived")
         dispatch(AuditorListSuceess(json))
       }})
     .catch(error => { 
     return{ type: "AGENT_LIST_SEARCH_ERROR", showerror:true, errmessage:error.message } })
    }
}
export function isPending(){
  return {
    type: "IS_PENDING",
    isPending:true
  }
}

export function AuditorListSuceess (data){
  if(data.status === 1001 && !_.isEmpty(data.value)){
  return {
      type: "AUDITOR_LIST",
      auditorList: data.value,
      isPending:false
    }
  } else {
   return{ type: "AGENT_LIST_SEARCH_ERROR", showerror:true, errmessage:data.message, isPending:false }
  } 
}
export function AgentListSearch(obj){
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
  fetch(URL_API_USER_DATA_AGENT_SEARCH, {
    method: 'POST',
    headers : headers,
    body:JSON.stringify(obj)
  }).then((res) => res.json()) 
    .then(json => {
     if(json.status === 403){
      dispatch(showModalLogin(json))
     } else {
       dispatch(AgentListSearchSuccess(json))
     }})
    .catch((data) => dispatch({type: "AGENT_LIST_SEARCH_ERROR", showerror:true, errmessage:data.message}))
  }
}
export function AgentListSearchSuccess(data){
  if(data.status === 1001){
  return {
    type: "AGENT_LIST_SEARCH",
    agentList: data.value
    }
  } else {
    return{ type: "AGENT_LIST_SEARCH_ERROR", showerror:true, errmessage:data.message, isPending:false}
  }
}
export function SupervisorSearch(obj){
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
  fetch(URL_API_USER_DATA_SUPERVISOR_SEARCH, {
    method: 'POST',
    headers : headers,
    body:JSON.stringify(obj)
  }).then((res) => res.json()) 
    .then(json => {
     if(json.status === 403){
      dispatch(showModalLogin(json))
     } else {
       dispatch(SupervisorSearchSuccess(json))
     }})
    .catch((data) => dispatch({type: "AGENT_LIST_SEARCH_ERROR", showerror:true, errmessage:data.message}))
  }
}
export function SupervisorSearchSuccess(data){
  if(data.status === 1001){
  return {
      type: "SUPERVISOR_LIST_SEARCH",
      supervisor: data.value
    }
  } else {
    return{ type: "AGENT_LIST_SEARCH_ERROR", showerror:true, errmessage:data.message}
  }
}


export function MappedAgentsListView(obj){
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    dispatch(isPending())
  fetch(URL_API_MAPPED_AGENTS_LIST_VIEW, {
    method: 'POST',
    headers : headers,
    body:JSON.stringify(obj)
  }).then((res) => res.json()) 
    .then(json => {
     if(json.status === 403){
      dispatch(showModalLogin(json))
     } else {
       dispatch(MappedAgentsListViewSuccess(json))
     }})
    .catch((data) => dispatch({type: "AGENT_LIST_SEARCH_ERROR", showerror:true, errmessage:data.message,isPending:false}))
  }
}
export function MappedAgentsListViewSuccess(data){
  if(data.status === 1001){
  return {
      type: "MAPPED_AGENT_LIST_VIEW",
      mappedAgentList: data.value,
      isPending:false
    }
  } else {
    return{ type: "AGENT_LIST_SEARCH_ERROR", showerror:true, errmessage:data.message, isPending:false}
  }
}


export function mapAgentsAction(obj){
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
  fetch(URL_API_USER_DATA_AGENT_MAP, {
    method: 'POST',
    headers : headers,
    body:JSON.stringify(obj)
  }).then((res) => res.json())
    .then((data) => {
      if(data.status === 403){
        dispatch(showModalLogin())
       } else {
        dispatch({type: "AGENT_LIST_SEARCH_ERROR", showerror:true, errmessage:data.message, isPending:false})
       }
     })
    .catch((err)=> dispatch({type: "AGENT_LIST_SEARCH_ERROR", showerror:true, errmessage:err.message, isPending:false})) 
    
  }
}
export function closeModalPopUp(){
  return{
    type:'AGENT_ACTION_MODAL_CLOSE',
    showerror:false
  }

}

export function ReAssignAgents(obj) {  
  return (dispatch, getState) => { 
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization", currentToken);
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_REASSIGN_AGENTS, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then(res=>res.json())
     .then(json => {
       if(json.status === 403){
        dispatch(showModalLogin(json))
       } else {
         //
       }})
     .catch(error => { 
      //
      })
    }
}
